import HowToDash from './how-to-dash'
import { slideItemList } from './slide-decks'

export const howToDashSlides = slideItemList()
export default HowToDash
